import { render } from "./AddContract.vue?vue&type=template&id=61b64416&scoped=true&ts=true"
import script from "./AddContract.vue?vue&type=script&lang=ts"
export * from "./AddContract.vue?vue&type=script&lang=ts"

import "./AddContract.vue?vue&type=style&index=0&id=61b64416&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b64416"]])

export default __exports__